import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, FabContainer, AlertController, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { Workplace } from '../../models/workplace';
import { WorkplaceProvider } from '../../providers/workplace/workplace';

declare var google;

@IonicPage()
@Component({
  selector: 'page-map',
  templateUrl: 'map.html',
})
export class MapPage {

  @ViewChild('MAP') mapElement: ElementRef;
  addMode: boolean;
  map: any;
  mode;

  private numVertex: number = 0;
  private path: Array<{lat: any, lng: any}>;
  private polygon;
  private workplaces = [];
  private workplaceSubscription;
  
  constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public workplaceProvider: WorkplaceProvider,
  ){
    this.mode = this.navParams.get('mode');
  }

  ionViewDidLoad() {  
    this.loadMap();
  }

  ionViewWillUnload() {
    if(this.workplaceSubscription && !this.workplaceSubscription.closed) this.workplaceSubscription.unsubscribe();
  }
  
  public activateDrawingMode(fab: FabContainer) {
    this.addMode = true;
    this.map.setOptions({ gestureHandling: 'none' });

    fab.close();
  }

  public discardWorkplace(fab: FabContainer) {
    this.numVertex = 0;
    this.path = [];
    if(this.polygon) this.polygon.setMap(null);

    this.addMode = false;
    this.map.setOptions({ gestureHandling: 'auto' });
    fab.close();
  }
  
  public saveWorkplace(fab: FabContainer) {
    console.log(this.numVertex)
    if(this.numVertex > 2) {
      this.alertCtrl.create({
        title: 'Añadir centro de trabajo',
        inputs: [
          {
            name: 'name',
            placeholder: 'Nombre'
          }
        ],
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            handler: data => {}
          },
          {
            text: 'Añadir',
            handler: data => {
  
              this.numVertex = 0;
              var arrayLatlng = this.polygon.getPath().getArray();
              var path = [];
  
              for(let i = 0; i < arrayLatlng.length; i++) {
                path.push(arrayLatlng[i].toJSON());
              }
  
              this.workplaceProvider.save({ name: data.name, coords: path } as Workplace);
  
              this.navCtrl.pop();
            }
          }
        ]
      }).present();
      
      fab.close();
    }

    else this.showMessage('El polígono debe tener más de 2 vértices.')
  }

  private addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }

  private addMarker(check) {
    let lat = check.coords.lat;
    let lng = check.coords.lng;

    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: { lat: lat, lng: lng }
    });

    // Bounds del mapa, amb el marker com a centre
    let bounds = new google.maps.LatLngBounds({ lat: lat, lng: lng });
    this.map.fitBounds(bounds);
    this.map.setZoom(this.map.getZoom() - 1)
    
    let content = '<b>' + check.type + '</b><br>' + (new Date(check.timestamp)).toLocaleString() + '<br>' + check.delayString;
    this.addInfoWindow(marker, content);
  }

  private attachDrawingListener() {
    this.path = [];

    // Dibuixar polígons
    google.maps.event.addListener(this.map, 'dblclick', snap => {
      if (this.addMode == true) {
        if(this.polygon) this.polygon.setMap(null);
        this.path.push({lat: snap.latLng.lat(), lng: snap.latLng.lng()});          
        
        // iniciar polígon
        this.polygon = new google.maps.Polygon({
          paths: this.path,
          strokeColor: globalDefines.drawingPolygonStrokeColor,
          strokeOpacity: globalDefines.drawingPolygonStrokeOpacity,
          strokeWeight: globalDefines.drawingPolygonStrokeWeight,
          fillColor: globalDefines.drawingPolygonFillColor,
          fillOpacity: globalDefines.drawingPolygonFillOpacity,
          clickable: false,
          editable: true,
        });

        this.polygon.setMap(this.map);
        this.numVertex++;
      }
    });
  }
  
  private attachPolygonInfoWindow(polygon, name) {
    var infoWindow = new google.maps.InfoWindow();
    google.maps.event.addListener(polygon, 'click', function (e) {
      infoWindow.setContent(name);
      infoWindow.setPosition(e.latLng);
      infoWindow.open(this.map);
    });
  }

  private drawWorkplace(workplace) {
    var polygon = new google.maps.Polygon({
      path: workplace.coords,
      strokeColor: globalDefines.polygonStrokeColor,
      strokeOpacity: globalDefines.polygonStrokeOpacity,
      strokeWeight: globalDefines.polygonStrokeWeight,
      fillColor: globalDefines.polygonFillColor,
      fillOpacity: globalDefines.polygonFillOpacity,
      map: this.map
    });

    // Create the bounds object
    var bounds = new google.maps.LatLngBounds();
    polygon.getPath().forEach(function (path, index) {
      bounds.extend(path);
    });

    this.map.fitBounds(bounds);

    this.attachPolygonInfoWindow(polygon, workplace.name);
  }

  private getWorkplaces() {    
    // Carregar llocs de treball
    this.workplaceSubscription = this.workplaceProvider.getWorkplaces().subscribe(workplaces => {
    
      // Eliminar polígons existents
      this.workplaces.map(workplace => workplace.polygon.setMap(null));
      this.workplaces = workplaces;

      workplaces.map(workplace => {
        let polygon = new google.maps.Polygon({
          path: workplace.coords,
          strokeColor: globalDefines.polygonStrokeColor,
          strokeOpacity: globalDefines.polygonStrokeOpacity,
          strokeWeight: globalDefines.polygonStrokeWeight,
          fillColor: globalDefines.polygonFillColor,
          fillOpacity: globalDefines.polygonFillOpacity,
          map: this.map
        });
        
        this.attachPolygonInfoWindow(polygon, workplace.name);

        workplace['polygon'] = polygon;
      });
    });
  }

  private loadMap() {
    let latLng = new google.maps.LatLng(40.184892, -3.758568);
    let mapOptions = {
      zoom: 4,
      center: latLng,
      mapTypeId: 'satellite',
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      },
      
      fullscreenControl: false,
      streetViewControl: false,
    }
    
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.modeFeatures()
  }

  private modeFeatures() {
    switch(this.mode) {
      case 'check': {
        let check = this.navParams.get('check')
        this.addMarker(check);
        this.getWorkplaces();
        break;
      }

      case 'workplace': {
        let workplace = this.navParams.get('workplace');
        this.drawWorkplace(workplace);
        break;
      }

      case 'addWorkplace': {
        this.getWorkplaces();
        this.attachDrawingListener();
      }
    }
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/map/map.ts